import { DatePipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MsalBroadcastService, MsalGuard, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';

import { HttpRequestInterceptor } from './interceptor/http-request.interceptor';
import { LoadingService } from './services/loading.service';
import { ReportService } from './services/report.service';
import { loadingSpinnerInterceptorFunctional } from './services/functional.interceptor';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './msal.config';
import { US_DATE_FORMATS } from './app.constants';

export const appProviders = [
  LoadingService,
  DatePipe,
  ReportService,
  DecimalPipe,
  { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
  { provide: MAT_DATE_FORMATS, useValue: US_DATE_FORMATS },
  provideHttpClient(withInterceptorsFromDi(), withInterceptors([loadingSpinnerInterceptorFunctional]), withFetch()),
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpRequestInterceptor,
    multi: true
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory
  },
  MsalService,
  MsalGuard,
  MsalBroadcastService
];
